export enum DndBubbleTextFieldType {
  Title = 'Title',
  FrTitle = 'FrTitle',
  Link = 'Link',
  IsValid = 'IsValid',
  SubmitFormCallback = 'SubmitFormCallback',
  Sources = 'Sources',
}
